import React, { useEffect, useState, useRef } from "react";
import useDebounce from "../../../utils/useDebounce";
import "./styles.scss";
import companyServices from "../../../services/companyServices";
//import { actions as companyAction } from '../../../store/modules/company/actions'
//import { useDispatch, useSelector } from 'react-redux'
import { Nav } from "../../../../node_modules/react-bootstrap";
import CompanyBox from "../../../Company/components/CompanyBox";
import Diamante from "../../../assets/imagens/md-Diamante.png";
import Gold from "../../../assets/imagens/medalhas2020-reputacao-22.68a52cb9.png";
import Silver from "../../../assets/imagens/medalhas2020-reputacao-21.108fd159.png";
import Bronze from "../../../assets/imagens/medalhas2020-reputacao-20.f83bd0e2.png";

const CompanyList = () => {
  const imageRef = useRef();
  const [companies, setCompanies] = useState([]);
  const [searchCompany, setSearchCompany] = useState({});
  const [search, setSearch] = useState("");
  const [firstLoad, setFirstLoad] = useState(true);

  const SEARCH_DEBOUNCE_DELAY = 900;
  const debouncedSearchTerm = useDebounce(search, SEARCH_DEBOUNCE_DELAY);

  /** Delay to search store */
  useEffect(
    () => {
      if (debouncedSearchTerm && debouncedSearchTerm.length > 2) {
        if (search) {
          getSearchCompany(search).then((result) => {
            if (result) {
              setCompanies(result.Data);
            }
          });
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [debouncedSearchTerm]
  );

  const getCompanies = async (medal) => {
    const params = {
      active: true,
      shuffle: true,
      medal,
      order: null,
    };

    const companies = await companyServices.getAll(params);
    setCompanies([]);
    setCompanies(companies.Data);
    setFirstLoad(false);
  };

  const getSearchCompany = async (name) => {
    const params = {
      name,
    };
    return companyServices.getByName(params);
  };

  useEffect(() => {
    getCompanies("diamante");
  }, []);

  const handleClick = (medal) => {
    setSearch("");
    getCompanies(medal);
  };

  return (
    <>
      <div className="company-reputation">
        <h2 className="company-reputation__title">Reputação das lojas</h2>
        <p className="company-reputation__sub-title">
          Confira as avaliações dos usuários Ebit.
        </p>
      </div>

      <div className="store-search container">
        <input
          type="search"
          placeholder=" Busque por sua loja favorita!"
          value={search}
          onChange={(ev) => setSearch(ev.target.value)}
        />
      </div>

      <div className="teste-bg">
        <div className="container-fluid" style={{ backgroundColor: "white" }}>
          <Nav
            className="menu-reputation container"
            justify
            variant="tabs"
            defaultActiveKey="link-0"
          >
            <Nav.Item>
              <Nav.Link
                className="menu-reputation__link-box"
                eventKey="link-0"
                onClick={() => {
                  handleClick("diamante");
                }}
              >
                <div className="nav-categories">
                  <img
                    src={Diamante}
                    style={{ height: 30, margin: "5px 10px 5px 0" }}
                  />
                  Lojas Diamante
                </div>
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                className="menu-reputation__link-box"
                eventKey="link-1"
                onClick={() => {
                  handleClick("ouro");
                }}
              >
                <div className="nav-categories">
                  <img src={Gold} />
                  Lojas Ouro
                </div>
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                className="menu-reputation__link-box"
                eventKey="link-2"
                onClick={() => {
                  handleClick("prata");
                }}
              >
                <div className="nav-categories">
                  <img src={Silver} />
                  Lojas Prata
                </div>
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                className="menu-reputation__link-box"
                eventKey="link-3"
                onClick={() => {
                  handleClick("bronze");
                }}
              >
                <div className="nav-categories">
                  <img src={Bronze} />
                  Lojas Bronze
                </div>
              </Nav.Link>
            </Nav.Item>
          </Nav>
        </div>

        <div className="legend-satisfaction container">
          <div>
            <p className="fa fa-heart-o legend-satisfaction__icon return-purchase" />
            <p className="legend-satisfaction__text">Comprariam novamente</p>
          </div>
          <div>
            <p className="fa fa-calendar-check-o legend-satisfaction__icon delivery-time" />
            <p className="legend-satisfaction__text">Entrega no prazo</p>
          </div>
          <div>
            <p className="fa fa-comments-o legend-satisfaction__icon friend-recommendation" />
            <p className="legend-satisfaction__text">Indicaria a amigos</p>
          </div>
        </div>

        <div className="companies container">
          {companies.length > 0 ? (
            (companies || []).map((company) => <CompanyBox company={company} />)
          ) : firstLoad ? (
            <div className="warning-company">
              <h1>Carregando...</h1>
            </div>
          ) : (
            <div className="warning-company">
              <h1>
                Desculpe, não conseguimos encontrar a loja que está
                procurando...
              </h1>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default CompanyList;
